/**
 * Header ausblenden und beim hochscrollen wieder einblenden
 *
 * Das script blendet den Header aus und lässt ihn beim hochscrollen wieder einfahren.
 *
 * @param {string} selector - jQuery selecor der mit Plugin angesporchen wird
 *
 * Events: window.load
 *
 * @return {undefined}
 */

function nc_initScrollupbar(selector) {
    var moduleLogger = LoggerManager.get('scrollupbar').setPrefix('Selektor: ' + selector);
    moduleLogger.trace('INIT START');
        // Script wird on Window Load ausgeführt
        $(window).load(function () {
            nc_scrollupbar(selector);
        });
        // Script on resize neu initialisieren | Berechnung
        $(window).resize(function () {
            nc_scrollupbar(selector);
        });
    moduleLogger.info('INIT ENDE');
}


/**
 * @see nc_initScrollupbar
 */
function nc_scrollupbar(selector) {
    var moduleLogger = LoggerManager.get('scrollupbar').setPrefix('Selektor: ' + selector);
    moduleLogger.trace('SCRIPT START');
    // Nur ausführen wenn der Browser breiter als 767px (xs) ist (den addon-top wird auf xs ausgeblendet)
    if (Modernizr.mq('(min-width: 767px)')) {
        // Script auf den selector ausführen
        $(selector).scrollupbar();
        // Dem unterliegenden Element ein padding top verpassen in Höhe des selectors
        $(selector).parent().next().css({
            "padding-top": $(selector).outerHeight(),
        });
    }
    moduleLogger.info('SCRIPT ENDE');
}
